/**
 * Created by lu on 2018/1/31.
 */
var nb = require('../../nb');
var SeriesList = nb.define({
    parent:nb.model.List,
    method:{
       init:function () {
           this.set('itemType',require('../../view/header/SeriesItem'));
           this.onChange('items',function (inEvent,inItems) {
               $.each(inItems,function (index,item) {
                   item.set('seriesHref','series.html?id='+item.get('id'));
               });
           });
       }
    }
});
var businessList = nb.define({
    parent:nb.model.List,
    method:{
        init:function () {
            this.set('itemType',require('../../view/header/BusinessItem'));
            this.onChange('items',function (inEvent,inItems) {
                $.each(inItems,function (index,item) {
                    item.set('businessHref',item.get('href')+".html");
                });
                // $.each(inItems,function (index,item) {
                //     item.set('seriesHref','series.html?id='+item.get('id'));
                // });
            });
        }
    }
});
module.exports = nb.define({
    parent:nb.Model,
    mapping:{
        seriesList:SeriesList,
        businessList:businessList
    },
    method:{
        init:function () {

        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/Dialog.js
// module id = 46
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32